import { useNavigate } from "react-router-dom";
import { COLORS, FONTS } from "@/lib/constants";

export default function BillingCancel() {
  const navigate = useNavigate();
  return (
    <div
      data-testid="billing-cancel-screen"
      style={{
        minHeight: "100vh",
        background: COLORS.bg,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 20,
      }}
    >
      <div
        style={{
          maxWidth: 480,
          background: COLORS.surface,
          border: `1px solid ${COLORS.border}`,
          borderRadius: 16,
          padding: 32,
          textAlign: "center",
        }}
      >
        <div style={{ color: COLORS.textPrimary, fontFamily: FONTS.heading, fontSize: 24, marginBottom: 12 }}>
          Payment cancelled
        </div>
        <div style={{ color: COLORS.textSecondary, fontFamily: FONTS.body, fontSize: 15, marginBottom: 24 }}>
          No worries. You can pick up where you left off, or try again later.
        </div>
        <button
          onClick={() => navigate("/paywall")}
          data-testid="billing-try-again-btn"
          style={{
            background: COLORS.mirror,
            color: "var(--yuo-ink-strong)",
            borderRadius: 999,
            padding: "12px 22px",
            fontFamily: FONTS.body,
            fontSize: 14,
            fontWeight: 600,
          }}
        >
          Back to plans
        </button>
      </div>
    </div>
  );
}
